import { ISearchProductAndPageClickGtmDataObject } from "../../shared/googleTagManager/gtmDataObject";
import { GoogleTagManager } from "../../shared/googleTagManager/gtmService";
import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { GoogleTagManagerEnums } from "../../shared/utilities/enums/googleTagManagerEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";

export interface ISearchGtmItem extends IInstanceComponentBase {
    url: string;
    name: string;
    sendSearchProductAndPageClickGtmDataObjectAndNavigate: (listValue: GoogleTagManagerEnums.SearchClickListValues) => void;
}

export class SearchGtmItem extends InstanceComponentBase implements ISearchGtmItem {
    public url: string;
    public name: string;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this.setUrlAndName();
    }

    sendSearchProductAndPageClickGtmDataObjectAndNavigate(listValue: GoogleTagManagerEnums.SearchClickListValues): void {
        try {
            let dataObject: ISearchProductAndPageClickGtmDataObject = {
                url: this.url,
                name: this.name,
                list: listValue,
                term: this.getSearchInputValue()
            };

            let eventType: GoogleTagManagerEnums.EventTypes;

            if (listValue === GoogleTagManagerEnums.SearchClickListValues.Product) {
                eventType = GoogleTagManagerEnums.EventTypes.SearchProductClick;
            }
            else {
                eventType = GoogleTagManagerEnums.EventTypes.SearchPageClick;
            }

            GoogleTagManager.sendSearchProductAndPageClickGtmDataObjectAndNavigate(dataObject, eventType, this.url);
        } catch (error) {
            console.log('SearchGtmItem: sendSearchProductAndPageClickGtmDataObjectAndNavigate Error', Error);
        }
    }

    getSearchInputValue(): string {
        try {
            let searchElement = this.htmlElement.closest(HelperUtils.addDataAttributeTags(AttributeEnums.SearchBase.Search));
            let searchInputElement: HTMLInputElement = searchElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.Input));
            let inputValue = searchInputElement.value;
            return inputValue;
        } catch (error) {
            console.log('SearchGtmItem: getSearchInputValue Error', Error);
            throw new Error('SearchGtmItem: getSearchInputValue failed to get Input value');
        }
    }

    setUrlAndName(): void {
        try {
            this.url = this.htmlElement.getAttribute(AttributeEnums.SearchGtm.GtmSearchItemUrl);
            this.name = this.htmlElement.getAttribute(AttributeEnums.SearchGtm.GtmSearchItemName);
        } catch (error) {
            console.log('SearchGtmItem: setUrlAndName ERROR', error);
        }
    }


    dispose(): void {

    }

}